import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import { fetchHomepageIfNeeded } from '../../actions'
import Profile from '../../classes/profile'
import Spinner from '../../components/Spinner'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'

class GroupDiscoverContainer extends React.Component {
  static propTypes = {
    profile: Profile.PropTypes,
    homepage: PropTypes.object,
    fetchHomepage: PropTypes.func.isRequired
  }

  componentDidMount () {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (homepage) {
      const discoverId = homepage.details.discover_entities.filter(e => e.is_default)
      const discoverEntityId = discoverId.length > 0 && discoverId[0].entity_id
      if (discoverEntityId) {
        this.setState({redirectTo: `/insights/rediscover/${discoverEntityId}`})
      }
      else {
        this.setState({redirectTo: '/insights/library'})
      }
    } else {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.homepage !== this.props.homepage) {
      if (!this.props.homepage.isFetching) {
        if (this.props.homepage.details && this.props.homepage.details.discover_entities && this.props.homepage.details.discover_entities.length > 0) {
          const discoverId = this.props.homepage.details.discover_entities.filter(e => e.is_default)
          const discoverEntityId = discoverId.length > 0 && discoverId[0].entity_id
          if (discoverEntityId) {
            this.setState({redirectTo: `/insights/rediscover/${discoverEntityId}`})
          }
        } else {
          this.setState({redirectTo: '/insights/library'})
        }
      }
    }
  }

  render () {
    if (this.state && this.state.redirectTo) {
      return (<Redirect to={this.state.redirectTo} />)
    } else {
      return (<Spinner />)
    }
  }
}

const mapStateToProps = () => {
  return (state) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const homepage = state.homepage.list
    return {
      profile,
      homepage
    }
  }
}

function mapDispatchToProps () {
  return (dispatch) => {
    return {
      fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupDiscoverContainer)
